export const initalCartState = [];

export const CartTypes = {
  ADD: 'add',
  REMOVE: 'remove',
  SUBTRACT: 'subtract',
  CLEAR: 'clear',
};

const findItem = (cart, itemId) => cart.find((item) => item.itemId === itemId);

export const cartReducer = (state, action) => {
  switch (action.type) {
    case CartTypes.ADD:
      if (findItem(state, action.itemId)) {
        return state.map((item) => (item.itemId === action.itemId
          ? { ...item, quantity: item.quantity + 1 }
          : item));
      }
      return [...state, { itemId: action.itemId, quantity: 1 }];
    case CartTypes.REMOVE:
      return state.filter((item) => item.itemId !== action.itemId);
    case CartTypes.SUBTRACT:
      if (findItem(state, action.itemId) && findItem(state, action.itemId).quantity > 0) {
        return state.map((item) => (item.itemId === action.itemId
          ? { ...item, quantity: item.quantity - 1 }
          : item));
      }
      return state;
    case CartTypes.CLEAR:
      return [];
    default:
      throw new Error(`Unknown action type ${action.type}`);
  }
};
